"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  buildTime: '2026-02-23T18:23:25Z',
  commit: 'aa09685725f8b4b928f10df372ae6422ca570082',
  npmInfo: {
    'solid-panes': '4.2.3',
    npm: '10.8.2',
    node: '20.20.0',
    acorn: '8.15.0',
    ada: '2.9.2',
    ares: '1.34.6',
    brotli: '1.1.0',
    cjs_module_lexer: '2.1.0',
    cldr: '47.0',
    icu: '77.1',
    llhttp: '9.3.0',
    modules: '115',
    napi: '9',
    nghttp2: '1.61.0',
    openssl: '3.0.17',
    simdutf: '6.4.2',
    tz: '2025b',
    undici: '6.23.0',
    unicode: '16.0',
    uv: '1.46.0',
    uvwasi: '0.0.23',
    v8: '11.3.244.8-node.33',
    zlib: '1.3.1-470d3a2'
  }
};
//# sourceMappingURL=versionInfo.js.map